import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import nodeAPI from '../service/ApiServiceNode';
import roleService from '../service/RoleService';

const AspireAccessContext = createContext(null);

function currentAccess() {
    return {
        canAccess: roleService.canAccessAspireInvoiceAllocation(),
        canProcess: roleService.canProcessAspireInvoiceAllocation(),
        canManage: roleService.canManageAspireCardAccess(),
    };
}

function unwrapSummary(response) {
    return response?.data?.data || response?.data || {};
}

export function AspireAccessProvider({ children }) {
    const [access, setAccess] = useState(currentAccess);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        setLoading(true);
        try {
            const response = await nodeAPI.get('/finance/aspire-invoice-allocation/access/summary');
            const summary = unwrapSummary(response);
            roleService.setAspireAccessSummary(summary);
            const nextAccess = currentAccess();
            setAccess(nextAccess);
            return nextAccess;
        } catch (_error) {
            roleService.setAspireAccessSummary(null);
            const fallbackAccess = currentAccess();
            setAccess(fallbackAccess);
            return fallbackAccess;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        void refresh();
    }, [refresh]);

    const value = useMemo(() => ({ ...access, loading, refresh }), [access, loading, refresh]);
    return <AspireAccessContext.Provider value={value}>{children}</AspireAccessContext.Provider>;
}

export function useAspireAccess() {
    const context = useContext(AspireAccessContext);
    if (context) return context;
    return { ...currentAccess(), loading: false, refresh: async () => currentAccess() };
}
